const logger = process.env.TEST ? {} : console
// NOTE we only log if testing
// TODO documentation

const panopliSend = '5ba8aa7b159e5b7c1811f2c8'
const selfSend = ''
/**
 * @return {String} id if valid or panopliSend if not
 * @param {String} id the incoming id
 */
// TODO stringify and check for admissible values
const checkSupplier = (id, fallBack = panopliSend) => (id || fallBack)

const getSupplierFromStock = (stock, product) => {
  try {
    if (!stock) {
      if (product.custom && product.picsDefaultToRegularProduct) {
        // NOTE FIXME probably wrong? not all will have a supplierId maybe?
        return checkSupplier(product.supplierId)
      }

      return checkSupplier(product.baseProduct.supplierId)

      // NOTE Full Custom also have a baseProduct as standard
    }
    if (stock.qty < product.quantity) {
      if (stock.oosPolicy === 'produce') {
        // NOTE FIXME nope -> if produce it doesn't come out of  the stock
        return checkSupplier(stock.shipperId)
      }

      throw Error('no supplier')
    }
    return checkSupplier(stock.shipperId)
  } catch (e) {
    console.log('error', e)
    return panopliSend
  }
}

/**
 * @return {Number} -1 if error, 0 if oos, 1 (red/alert) / 2 (waring/orange) / 3 (green/ok) depending on the stock levels
 * @param {Array} stock the stock array of a product
 */

// TODO move to config
const defaultThresholds = {
  alertThreshold: 5,
  warningThreshold: 10,
}
const stockRating = (stock, entityId) => {
  try {
    if (!stock || !stock.length ) return 3
    const oosStock = stock.find((s) => s.qty === 0 && s.oosPolicy !== 'produce' && s.entityId === entityId)
    if (oosStock) return 0
    const alertStock = stock.find((s) => s.qty < (s.alertThreshold || defaultThresholds.alertThreshold) && s.oosPolicy !== 'produce' && s.entityId === entityId)
    if (alertStock) return 1
    return 3
  } catch (error) {
    console.log('error panopli-packages/stocks/stockRating', { error })
    return -1
  }
}

/**
 * @return {Object} the relevant stock
 * @param {Object} product the product Object
 * @param {Object} orderedVariations the selected variations (color and size)
 */

 const getStock = (product, orderedVariations, stocks) => {
  try {
    // TODO CHECK IF WE CAN ALWAYS GET ENTITYID IN PRODUCT
    const { entityId } = product
    const { color, size } = orderedVariations
    console.log('getStock.entityId === ', entityId)
    console.log('getStock.productId === ', product.id || product._id)
    const filteredStocks = stocks ? stocks.filter((stock) => stock.productId === String(product.id || product._id) && entityId === stock.entityId ) : [] 
    return filteredStocks.find((stock) => {
      const { variationCombo = [] } = stock
      const colorCondition = variationCombo.find((variation) => variation.type === 'color' &&
      variation.reference === color.reference)
      const sizeCondition = variationCombo.find((variation) => variation.type === 'size' &&
      variation.reference === size.reference)
      return colorCondition && sizeCondition
    })
  } catch (e) {
    console.log('getStock2 error', e)
    return false
  }
}
// const getStock = (product, orderedVariations) => {
//   try {
//     if (product.stock && product.stock.length) {
//       const stock_nonSpecific = product.stock.find(stock => !stock.variationSpecific)
//       const stock_specific = product.stock.find((stock) => {
//         // NOTE variation combo match
//         try {
//           const condition = Object.values(orderedVariations)
//             .map(variation => variation.name)
//             .filter(name => stock.variationCombo.indexOf(name) !== -1)
//             .length === stock.variationCombo.length
//           return condition
//         } catch (error) {
//           return false
//         }
//       })
//       // NOTE TODO we should dociument this (specific is priorised if found)
//       const stock = stock_specific || stock_nonSpecific
//       return stock
//     }
//     return false
//   } catch (error) {
//     logger.log({
//       level: 'err',
//       message: 'getStock',
//       error,
//     })
//     return false
//   }
// }

/**
 * getStockPlateformFeeImpact will return the PFI for the relevant stock
 * @param {Object} product a product object with selected variations
 * @return {Number} what we bill additionnaly for using that stock (can be < 0)
 */
const getStockPlateformFeeImpact = (product, stocks) => {
  try {
    // TODO check for oosPolicy
    const stock = getStock(product, product.variations, stocks)
    if (product.quantity <= stock.qty) {
      const result = stock.plateformFeeImpact || 0
      return result
    }
    return 0
  } catch (error) {
    logger.log('getStockPlateformFeeImpact', { error, product })
    return 0
  }
}

// TODO isOOS (product, variations) => Boolean

module.exports = { getStockPlateformFeeImpact, getSupplierFromStock, getStock, stockRating }
